/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import { UTR } from '../../constants/labels';
import FileGrid from './file-grid';
import { normalizeEvidence } from '@utils/survey/evidence';
import { HistoryDocument } from '@g17eco/types/document';
import { ValueHistory } from '@g17eco/types/universalTrackerValue';

interface EvidenceModalProps {
  history: ValueHistory | undefined;
  isOpen: boolean;
  documents: HistoryDocument[];
  toggle: React.MouseEventHandler;
}

export class EvidenceModal extends React.Component<EvidenceModalProps> {
  docModal: Modal | null = null;

  renderHistoryEvidenceFiles = (history: ValueHistory | undefined, documents: HistoryDocument[], zIndex = 10) => {
    if (!history) {
      return '';
    }

    // Normalize evidence data (handles both new evidenceData and legacy evidence formats)
    const evidenceData = normalizeEvidence(history);

    if (evidenceData.length === 0) {
      return '';
    }

    // Map evidence to document files with descriptions
    const files = evidenceData.reduce<HistoryDocument[]>((acc, evidence) => {
      const doc = documents.find(d => d._id === evidence.documentId);

      if (doc) {
        acc.push({
          ...doc,
          description: evidence.description
        });
      }

      return acc;
    }, []);

    return <div className='mt-0 mb-4'>
        <FileGrid zIndex={zIndex} files={files}/>
      </div>
  };

  render() {
    const { history, isOpen, documents, toggle } = this.props;
    const modalZIndex = this.docModal ? this.docModal.props.zIndex : undefined;
    const zIndex = typeof modalZIndex === 'number' ? modalZIndex + 1 : undefined;

    return (
      <Modal ref={(modal) => (this.docModal = modal)} isOpen={isOpen} toggle={toggle} backdrop='static'>
        <ModalHeader toggle={toggle}>{UTR.FILES}</ModalHeader>
        <ModalBody>
          <div className='fileList'>{this.renderHistoryEvidenceFiles(history, documents, zIndex)}</div>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}
